import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer/Footer';
import piri_logo from '../assets/images/about/piri_logo.png';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const MAX_QUESTIONS = 3;

const DemoPage = () => {
    const { t } = useTranslation();
const navigate = useNavigate();

    // localStorage'dan soru hakkını oku, yoksa MAX_QUESTIONS
    const storedQuestionsLeft = localStorage.getItem('questionsLeft');
    const initialQuestionsLeft = storedQuestionsLeft !== null ? Number(storedQuestionsLeft) : MAX_QUESTIONS;

    const [inputText, setInputText] = useState('');
    const [responseText, setResponseText] = useState('');
    const [questionsLeft, setQuestionsLeft] = useState(initialQuestionsLeft);
    const [loading, setLoading] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);

    const LONG_RESPONSE_TEXT = `metrikler üzerinden yürütülmüştür. Ancak, ağların büyüklüğü ve karmaşıklığı arttıkça, bu yöntemlerin sınırlılıkları ortaya çıkmıştır. Özellikle heterojen ve çok katmanlı ağlarda, düğümlerin tam anlamıyla temsil edilmesi ve grupların doğru şekilde tespit edilmesi zorlaşmaktadır. Hu ve arkadaşlarının çalışmasında, sosyal ağlardaki toplulukların tespitinin metodolojik ve pratik açıdan önemli olduğu, ancak mevcut yöntemlerin heterojen ağlarda kullanıcıların tam özellik ifadelerini göz ardı ettiği belirtilmiştir (Hu, P., Niu, Z., He, T., C.C., & K., 2018). Bu nedenle, daha kapsamlı ve derin temsillerin öğrenilmesi gerekliliği vurgulanmıştır.
   Başarı sağlamaktadır. Tan ve arkadaşlarının derlemesinde, sosyal ağ analizinde temel adımın, ağ verisinin düşük boyutlu temsillere (network embeddings) dönüştürülmesi olduğu ve bu temsillerin sınıflandırma, bağlantı tahmini, anomali tespiti ve kümelenme gibi uygulamalarda kullanıldığı belirtilmiştir (Tan, Q., Liu, N., Hu, & X., 2019). Ayrıca, derin sinir ağları tabanlı tekniklerin, son yıllarda sosyal ağ temsili öğrenmede büyük ilgi gördüğü ve çeşitli ağ türleri (homojen, heterojen, dinamik) için farklı modellemeler geliştirildiği ifade edilmiştir.
Anahtar Kelimeler: Deep Learning, Social Network Analysis, Community Detection
Kaynakça
- Neslihan KESER, Oğuzhan ÖZDEMİR, Oğuzhan Özdemir, Neslihan Keser, . (2019). Öğrencilerin Öğrenme Ortamlarındaki Sosyal Ağ Rollerinin Karşılaştırılmasına İlişkin Bir Ağ Analizi. Turkish Journal of Educational Studies, 6(2), 1-30. DOI: https://doi.org/10.33907/turkjes.559160
- Pengwei Hu, Zhaomeng Niu, Tiantian He, Keith C.C. Chan, . (2018). Learning Deep Representations in Large Integrated Network for Graph Clustering. 2018 IEEE First International Conference on Artificial Intelligence and Knowledge Engineering (AIKE), 101-105. DOI: https://doi.org/10.1109/aike.2018.00022
`;


    // questionsLeft değiştikçe localStorage'a yaz
    useEffect(() => {
        localStorage.setItem('questionsLeft', questionsLeft);
    }, [questionsLeft]);

    const handleGenerate = async () => {
        if (!inputText.trim()) return;

        if (questionsLeft <= 0) {
            alert(t('Soru hakkınız kalmadı. Lütfen giriş yapın.'));
            return;
        }



        setLoading(true);
        try {
            await new Promise(r => setTimeout(r, 1500));
            // fakeResponse yerine uzun metni kullan
            setResponseText(LONG_RESPONSE_TEXT);
            setShowOverlay(true);
            setQuestionsLeft(q => q - 1);
        } catch {
            alert(t('Bir hata oluştu.'));
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            <main className="flex-grow container mx-auto p-6 max-w-7xl flex gap-10">

                {/* Sol taraf: Piri AI tanıtımı */}
                <section className="w-1/3 bg-white rounded-lg shadow p-8 flex flex-col items-center">
                    <img src={piri_logo} alt="Piri AI Logo" className="w-32 mb-6" />
                    <h2 className="text-3xl font-bold text-[#3c4f58] mb-4">{t('Piri AI: Akademik Araştırmalar için Üretken Yapay Zeka')}</h2>
                    <p className="text-gray-700 text-justify">
                        {t('about3')}
                    </p>
                    <p className="text-gray-700 mt-4 text-justify">
                        {t('about4')}
                    </p>
                </section>

                {/* Sağ taraf: Demo input ve sonuç */}
                <section className="w-2/3 bg-white rounded-lg shadow p-8 flex flex-col">
                    <h1 className="text-3xl font-bold text-[#3c4f58] mb-4">{t('Piri AI Demo')}</h1>

                    <input
                        id="questionInput"
                        type="text"
                        value={inputText}
                        onChange={e => setInputText(e.target.value)}
                        placeholder={t('Bir Araştırma Sorusu Giriniz')}
                        className="w-full border border-gray-400 rounded px-4 py-2 mb-3 focus:outline-none focus:ring-2 focus:ring-blue-600"
                        disabled={questionsLeft <= 0}
                    />

                    <button
                        onClick={handleGenerate}
                        disabled={loading || questionsLeft <= 0}
                        className={`mb-4 py-2 px-6 bg-black-600 text-white rounded hover:bg-blue-700 disabled:bg-gray-400 transition`}
                    >
                        {loading ? t('Üretiliyor...') : t('Araştır ve Makale Yaz')}
                    </button>

                    <p className="mb-4 font-medium">{t('Kalan Soru Hakkı')}: {questionsLeft} / {MAX_QUESTIONS}</p>

                    {questionsLeft === 0 && (
                        <div className="mt-6 p-4 border border-yellow-400 bg-yellow-50 rounded text-yellow-700">
                            <p className="mb-4 text-lg font-semibold">
                                Hemen Ücretsiz Üye Olarak 3 Tane <span className="underline">"Tam Sorgu"</span> 'ya erişebilirsiniz.
                            </p>
                            <p className="mb-4">
                                Tam sorguda 10 sayfa ve 50 atıfa kadar yazabilirsiniz, Word olarak indirip kaynakça listesini alabilirsiniz ve daha fazlası...
                            </p>
                            <button
  onClick={() => navigate('/register')}
                                className="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
                            >
                                Üye Ol
                            </button>
                        </div>
                    )}


                    {responseText && (
                        <div className="relative max-h-196 overflow-hidden rounded border border-gray-300 bg-white p-4">
                            <p className="text-justify whitespace-pre-wrap">
                                {responseText}
                            </p>

                            {/* Alt kısımda soldan sağa kayarak silinen gradient */}
                            <div className="absolute bottom-0 left-0 w-full h-20 pointer-events-none"
                                style={{
                                    background: 'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))'
                                }}
                            />

                            {/* Üzerinde buton, pointer-events ile tıklanabilir */}
                            <div className="absolute bottom-4 left-0 w-full flex justify-center pointer-events-auto">
                                <button
                                    onClick={() => alert(t('Giriş sayfasına yönlendirilebilir'))}
                                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                                >
                                    {t('Tüm Özellikleri ile Kullanım için Ücretsiz Kayıt Olun!')}
                                </button>
                            </div>
                        </div>
                    )}

                </section>
            </main>

            <Footer />
        </div>
    );
};

export default DemoPage;
